import { useEffect, useState } from "react";
import { UsersThree } from "@phosphor-icons/react";
import { SettingsCrud } from "./SettingsCrud";
import api from "../../lib/api";

export function TeamsSettings() {
  const [branches, setBranches] = useState([]);
  const [depts, setDepts] = useState([]);
  const [leads, setLeads] = useState([]);

  useEffect(() => {
    api.get("/branches").then(({ data }) =>
      setBranches((data || []).filter((b) => b.active !== false).map((b) => ({ value: b.id, label: b.name })))).catch(() => {});
    api.get("/departments").then(({ data }) =>
      setDepts((data || []).filter((d) => d.active !== false).map((d) => ({ value: d.name, label: d.name })))).catch(() => {});
    api.get("/users").then(({ data }) =>
      setLeads((data || []).map((u) => ({ value: u.id, label: `${u.name} (${u.role})` })))).catch(() => {});
  }, []);

  return (
    <SettingsCrud
      testid="teams"
      title="Teams"
      icon={UsersThree}
      description="Group people into teams. Optionally link a team to a branch, department, and a team lead."
      endpoint="/teams"
      subtitle={(t) => [t.branch_name, t.department, t.lead_name && `Lead: ${t.lead_name}`].filter(Boolean).join(" · ")}
      fields={[
        { name: "name", label: "Team name", type: "text", required: true, placeholder: "e.g. North Sales Team" },
        { name: "branch_id", label: "Branch", type: "select", options: branches, allowEmpty: true, emptyLabel: "No branch" },
        { name: "department", label: "Department", type: "select", options: depts, allowEmpty: true, emptyLabel: "No department" },
        { name: "lead_user_id", label: "Team lead", type: "select", options: leads, allowEmpty: true, emptyLabel: "No lead" },
      ]}
    />
  );
}

export default TeamsSettings;
